import { render, staticRenderFns } from "./MyGrids.vue?vue&type=template&id=ecdcf466&scoped=true"
import script from "./MyGrids.vue?vue&type=script&lang=js"
export * from "./MyGrids.vue?vue&type=script&lang=js"
import style0 from "./MyGrids.vue?vue&type=style&index=0&id=ecdcf466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdcf466",
  null
  
)

export default component.exports